import { formatter } from './format';

export function getTax(price, tax_rates) {
	let tax = 0;
	tax_rates.forEach(_t => {
		if (_t.a) {
			tax += price * parseFloat(_t.rate || 0) / 100;
		}
	});
	return tax;
}

export function renderExtraContractorPriceTable(extra_contractor_prices) {
	if (extra_contractor_prices.length == 0) return '';

	let content = `<table><tr><td style="padding: 0px 10px;">Description</td>
		<td style="padding: 0px 10px;">Price</td>
		</tr>`;

	extra_contractor_prices.forEach(_s => {
		content += `<tr>
								<td style="padding: 0px 10px;">${_s.description}</td>
								<td style="padding: 0px 10px;">${formatter.format(_s.price)}</td>
						</tr>`;
	});
	content += '</table>';
	
	return content;
}


export function renderPriceTable(service_prices, has_desc=true) {
	if (service_prices.length == 0) return '';

	let content = `<table><tr>${has_desc ? '<td style="padding: 0px 10px;">Description</td>' : ''}
		<td style="padding: 0px 10px;">Rate</td>
		<td style="padding: 0px 10px;">Qty</td>
		<td style="padding: 0px 10px;">Tax</td>
		<td style="padding: 0px 10px;">Total</td>
		</tr>`;

	service_prices.forEach(_s => {
		let percent = 0;
		_s.tax_rates.forEach(_t => percent += _t.rate);
		content += `<tr>
								${has_desc ? '<td style="padding: 0px 10px;">' + _s.description + '</td>' : ''}
								<td style="padding: 0px 10px;">${formatter.format(_s.rate)}</td>
								<td style="padding: 0px 10px;">${_s.quantity}</td>
								<td style="padding: 0px 10px;">${percent}%</td>
								<td style="padding: 0px 10px;">${formatter.format(_s.rate * _s.quantity)}</td>
						</tr>`;
	});
	content += '</table>';
	
	return content;
}

export function renderMainServicePriceTable(service_prices) {
	let sps = [];
	service_prices.forEach(_sp => {
		if (_sp.is_main) sps.push(_sp);
	});
	return renderPriceTable(sps, false);
}

export function renderExtraServicePriceTable(service_prices) {
	let sps = [];
	service_prices.forEach(_sp => {
		if (!_sp.is_main) sps.push(_sp);
	});
	return renderPriceTable(sps, true);
}

export function getSubtotal(service_prices) {
	let price = 0;
	service_prices.forEach(_sp => price += _sp.rate * _sp.quantity);
	return price;
}

export function getTotalTax(service_prices) {
	let tax = 0;
	service_prices.forEach(_sp => {
		const price = _sp.rate * _sp.quantity;
		_sp.tax_rates.forEach(_t => tax += price * _t.rate / 100);
	});
	return tax;
}

export function convert_tax_rates(tax_rates, tax_rate_options) {
	return tax_rate_options?.map(_t => ({
		t: `${_t.name} (${_t.rate}%)`,
		a: tax_rates.find(_jt => _jt.id === _t.id) ? true : false,
		rate: _t.rate,
		comments: _t.comments,
		uid: _t.id,
	}));
}

export function get_main_service_price(service_prices, tax_rate_options) {
	let ret = {
		rate: 0,
		quantity: 0,
		price: 0,
		tax_rates: convert_tax_rates([], tax_rate_options)
	};
	service_prices.forEach(_p => {
		if (_p.is_main) ret = {
			..._p,
			price: _p.rate * _p.quantity,
			tax_rates: convert_tax_rates(_p.tax_rates, tax_rate_options)
		};
	});
	return ret;
}

export function get_extra_service_prices(service_prices, tax_rate_options) {
	let ret = [];
	service_prices.forEach(_p => {
		if (!_p.is_main) {
			ret.push({
				..._p,
				price: _p.rate * _p.quantity,
				tax_rates: convert_tax_rates(_p.tax_rates, tax_rate_options)
			})
		}
	});
	return ret;
}

export function description_validation_func(item) {
	if (item.description.length > 0) {
			item.description_show_error = false;
			return true;
	} else {
			item.description_show_error = true;
			item.description_error_text = 'Description is required';
			return false;
	}
};

export function rate_validation_func(item) {
	if (parseFloat(item.rate) > 0) {
			item.rate_show_error = false;
			return true;
	} else {
			item.rate_show_error = true;
			item.rate_error_text = 'Rate is required';
			return false;
	}
};

export function price_validation_func(item) {
	if (parseFloat(item.price) > 0) {
			item.price_show_error = false;
			return true;
	} else {
			item.price_show_error = true;
			item.price_error_text = 'Price is required';
			return false;
	}
};

export function quantity_validation_func(item) {
	if (parseFloat(item.quantity) > 0) {
			item.quantity_show_error = false;
			return true;
	} else {
			item.quantity_show_error = true;
			item.quantity_error_text = 'Quantity is required';
			return false;
	}
};

export function isNewLayout(obj) {
	return obj.service_prices.length > 0;
}